export var AcceptedMimeTypesEnum;
(function (AcceptedMimeTypesEnum) {
    AcceptedMimeTypesEnum["Pdf"] = "application/pdf";
    AcceptedMimeTypesEnum["MsWord"] = "application/msword";
    AcceptedMimeTypesEnum["DocX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    AcceptedMimeTypesEnum["Zip"] = "application/x-zip-compressed";
})(AcceptedMimeTypesEnum || (AcceptedMimeTypesEnum = {}));
export var acceptedMimeTypes = [
    AcceptedMimeTypesEnum.Pdf,
    AcceptedMimeTypesEnum.MsWord,
    AcceptedMimeTypesEnum.DocX,
    AcceptedMimeTypesEnum.Zip
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWNjZXB0ZWRNaW1lVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJBY2NlcHRlZE1pbWVUeXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxxQkFLWDtBQUxELFdBQVkscUJBQXFCO0lBQzdCLGdEQUF1QixDQUFBO0lBQ3ZCLHNEQUE2QixDQUFBO0lBQzdCLHlHQUFnRixDQUFBO0lBQ2hGLDZEQUFvQyxDQUFBO0FBQ3hDLENBQUMsRUFMVyxxQkFBcUIsS0FBckIscUJBQXFCLFFBS2hDO0FBRUQsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQWE7SUFDdkMscUJBQXFCLENBQUMsR0FBRztJQUN6QixxQkFBcUIsQ0FBQyxNQUFNO0lBQzVCLHFCQUFxQixDQUFDLElBQUk7SUFDMUIscUJBQXFCLENBQUMsR0FBRztDQUM1QixDQUFDIn0=